import { useRouter } from 'next/router';
import React from 'react';

import ListPageStates from '@/src/shared/components/ListPage/ListPageStates';
import useListSearch from '@/src/shared/hooks/useListSearch';
import states from '@/utils/states';

const searchOptions = {
  pubCode: 686,
  yearsBack: 5,
};

const LegislativePreview = props => {
  const router = useRouter();
  const { statecode } = props;
  const _statecode = statecode || router.query.slug;
  const [loading, results] = useListSearch(searchOptions, _statecode);

  return (
    <ListPageStates
      title="Legislative Preview"
      results={results}
      truncateResultSummary
      searchOptions={searchOptions}
      statecode={statecode}
      routeBase="/advocacy/state/legislative-preview"
      heroContent={<p>Documents from the last 5 years</p>}
      loading={loading}
    />
  );
};

export async function getStaticPaths() {
  return {
    paths: states.map(s => ({ params: { slug: s.StateCode } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      statecode: params.slug || 0,
    },
  };
}

export default LegislativePreview;
